// we need to be able to configure the animation name,
// and we need to be able to control the push-message component used.



/*
Data Format.
message: {

 

    id: string,
    template: string,
    zones: Array<string>,

 

    content: {
        header: string,
        body: string,
        class: string,
        link: {
            type: internal/external,
            text: string,
            url: string,
        }
    }
}
*/


Vue.component("PushMessages", {
    template: `
        <transition-group name="push-messages" tag="div" class="push-messages" v-on:after-leave="onMessageTransitionOutComplete">
            <component  
                v-for="(message, index) in getMessages" 
                :is="message.template" 
                :class="[message.template]"
                :key="keyGen('pm')"
                :cfg="message"
                @link-clicked="onLinkClicked(index, message)"
                @close="onCloseMessage(index, message)"
            ></component>
        </transition-group>
    `,

    data() {
        return {
            messages: [],
            messageDisplayQue: [],
            zones: [],
        }
    },
    mounted() {


        // todo: configure event name.
        app.radio.$on("message", this.pushMessage);


        // global Zones.
        this.zones = app.settings.has("pushMessageZones") ? app.settings.get("pushMessageZones").value.map(o => {

            var result = {};

            result.id = o.id.toLowerCase()
            


            result.value = [];
         

            try {

                var routes = eval(o.value);

                if(Array.isArray(routes)) {
               

                    routes.forEach(route => {
                        
                        var rv = route.replace(/\{root\}/g, app.defaultRoute)
                    
                        result.value.push(rv)
                    })

                }else {
                    app.logging.error("PushMessages", "ERROR route is not array but can be evaluated", result)
                }
            }
            catch (e) {

                app.logging.error("PushMessages", "cant eval the value... ", o.value, e.message)
                result.value.push(o.value.replace(/\{root\}/g, app.defaultRoute))
            }





            return result;
        }) : [];


    
        if (!app.settings.has("pushMessageZones")) {
            app.logging.error("PushMessages", "no push message zones defined in the manifest, no push messages will be shown.")
        }
    },
    computed: {
        getMessages() {
            return this.messages;
        },
    
    },
    methods: {
        onCloseMessage(messageIndex, message) {
            this.messages.splice(messageIndex, 1);
        },


        keyGen (prefix) {
            return prefix + "-"+ touchKit.utils.guid();
        },

        /**
         * 
         * @param message {data: Object {id:string, template:String, zones:Array<string>, content:any}} message 
         */
        pushMessage({ data }) {

            const message = data;
            app.logging.log("PushMessages","adding message", JSON.stringify(message));


            // checking zone
            // we need to check if we are on the correct zone:Array<String> to display the push message.
            // if not the message will not be shown, and will be lost for ever.


            // find the current zone>
            // comparing the current route with the zones defined it  manifest to find
            // the current zone.
            var zones = this.zones;
            var currentRoute = app.vm.$route.fullPath.replace(/:.*/g, "")
            var currentZone = null;

            // collect all matching zones
            var matchingZones = [];

            for (var zone in zones) {
                var obj = zones[zone]
                var matched = false;

                for(var item in obj.value) {

                    var route = obj.value[item]
   
                    var isMatch = new RegExp(`${route}`, "g").test(currentRoute);
                    app.logging.log("PushMessages",`testing ${obj.id.toLowerCase()} rule: ${route} == ${currentRoute}: ismatch: ${isMatch}`)

                    if (isMatch) {
                        app.logging.log("PushMessages",`${route} matches current route =${currentRoute}`);
                       // currentZone = obj.id.toLowerCase();
                        matched = true;
                        break;
                    } 
                }

                if(!matched) {
                    app.logging.log("PushMessages",`message.zones: ${message.zones} don't match the currentZone: ${currentZone}`);
                }else {
                    matchingZones.push(obj.id.toLowerCase())
                    //break;
                }
            }

            // is the message.zones with in one of the curreently matching zones ?
            app.logging.log("PushMessages","matching zones:")
            var matchedZone = matchingZones.find(zone => {
                app.logging.log("PushMessages", "\t", zone)
                return message.zones.some(id => id.toLowerCase() === zone.toLowerCase())
            })

            // check to see if the message.zones matches the currentZone.
            if (message.zones && matchedZone) {
                app.logging.log("PushMessages",`The messages zones ${message.zones} matched current zone ${matchedZone}`);
                // this.messages.push(message);
                this.displayMessage(message);
            } else {
                app.logging.log("PushMessages",`ignoring message, no zone matched message zones: ${message.zones}`)
            }
        },


        displayMessage(message) {

            // this should be configured globaly.
            var pushMessagesCanStack = false;



            if (pushMessagesCanStack) {
                this.messages.push(message);
            }
            else {


                // If no messages just show it.
                if (!this.messages.length) {
                    this.messages.push(message);
                }
                else {
                    // If there is already pushmessages being showed
                    // we add the message to a que, and empties the 
                    // messages, this will trigger the animation out
                    // and when that compleates we will display the new message
                    //saved in the que, in the onMessageTransitionOutComplete hook.
                    this.messageDisplayQue.push(message);
                    this.$nextTick().then(() => {
                        this.messages = []
                    })
                }

            }
        },

        onMessageTransitionOutComplete() {
            if (this.messageDisplayQue.length) {
                this.messages.push(this.messageDisplayQue.pop());
            }
        },

        onLinkClicked(messageIndex, message) {


            const link = message.content.link;

            switch (link.type) {
                case "internal":

                    const cleanedUrl = link.url.replace( /\{root\}/g, app.defaultRoute)
                    app.logging.log("PushMessages",`router.push => ${ cleanedUrl }`);
                    app.vm.$router.push(cleanedUrl);
                    break;

                case "external":
                    window.open(link.url, "_blank");
                    break;

                default:
                    app.logging.error("PushMessages", `unknown link type: ${link.type}`)
                    break
            }

            this.onCloseMessage(messageIndex, message);
        }
    }
})